import { useReactiveVar } from '@apollo/client'
import { userInfo } from 'api/graphQL/reactiveVars/user'
import { useFirmCreatedDate } from 'shared/hooks/useFirmCreatedDate'
import { useShouldHideWorkspaceToggle } from 'shared/hooks/useShouldHideWorkspaceToggle'
import { getFromLocalStorage } from 'shared/utils/workspaceUtils'

const useBetaWorkspaceToggle = () => {
    const { currentUserInfo } = useReactiveVar(userInfo)
    const { kpUserId: userId } = currentUserInfo

    // Check if this is a new firm that should have toggle hidden
    const { firmCreatedDate } = useFirmCreatedDate()
    const shouldHideToggle = useShouldHideWorkspaceToggle({ firmCreatedDate })

    const isBetaWorkspaceToggleEnabled = getFromLocalStorage(
        userId ?? '',
        'Global',
        'betaWorkspaceToggleChecked'
    )

    // For new firms (toggle hidden), always return true (new workspace)
    if (shouldHideToggle) {
        return true
    }

    // For old firms, default to false (classic workspace) if no value is stored (null)
    // Old firms should default to classic workspace
    return isBetaWorkspaceToggleEnabled === null ? false : isBetaWorkspaceToggleEnabled
}

export default useBetaWorkspaceToggle
